import io from 'socket.io-client';
import LocalStorage from 'store';

const APP_NAME = 'domicompro-client';
const DEVICE_KEY = 'deviceId_domicompro_client';

let socket = null;
let currentVendorId = null;

function buildQuery (vendorId) {
  return {
    vendorId: vendorId || null,
    deviceId: LocalStorage.get(DEVICE_KEY),
    app: APP_NAME
  };
}

export function initSocket (url) {
  if (socket) return socket;
  socket = io(url, {
    autoConnect: false,
    reconnection: true,
    forceNew: false,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    timeout: 10000,
    transports: ['websocket'],
    upgrade: false,
    query: buildQuery(null)
  });
  return socket;
}

export function getSocket () {
  return socket;
}

// Conecta (o reconecta) con el vendorId del restaurante actual.
// Sin vendorId no se conecta — el socket nunca debe abrirse anónimo.
export function connectSocket (vendorId) {
  if (!socket) return;
  if (!vendorId) {
    console.warn('[SOCKET] no se conecta — sin vendorId');
    return;
  }
  if (!LocalStorage.get(DEVICE_KEY)) {
    console.warn('[SOCKET] no se conecta — sin deviceId');
    return;
  }
  // Si ya estoy conectado al mismo vendor, no hago nada.
  if (socket.connected && String(currentVendorId) === String(vendorId)) return;
  currentVendorId = vendorId;
  socket.io.opts.query = buildQuery(vendorId);
  if (socket.connected) socket.disconnect();
  socket.connect();
}

export function disconnectSocket () {
  currentVendorId = null;
  if (socket && socket.connected) socket.disconnect();
}
